import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_SERVICIO_CLIENTE_PERMISSIONS = [
  PermissionsEnum.api_view_nodo,
  PermissionsEnum.api_view_nap,

  PermissionsEnum.api_view_contrato,
  PermissionsEnum.api_change_contrato,
];
